import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCKC2CrcuYuVAnoJULl7kfEtz5Ypf7ae4Q",
  authDomain: "exam-7101a.firebaseapp.com",
  databaseURL: "https://exam-7101a-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "exam-7101a",
  storageBucket: "exam-7101a.firebasestorage.app",
  messagingSenderId: "794250469921",
  appId: "1:794250469921:web:70158ed614f15673f93960",
  measurementId: "G-9GEYFNS13D"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const RTDB_URL = firebaseConfig.databaseURL;
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
